import { APP_TYPE, AppType } from "../app.type";
import { Component, Inject, OnDestroy, OnInit, Renderer2, DOCUMENT, ChangeDetectionStrategy } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "app-root",
    templateUrl: "./routing.component.html",
    styleUrls: ["./routing.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RoutingComponent implements OnInit, OnDestroy {
  private routeParamsSubscription: Subscription = new Subscription();

  private backgroundRoutes = [
    "login",
    "reset-password",
    "mfa-complete",
    "error",
  ];

  constructor(
    @Inject(APP_TYPE) private app: AppType,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    const backgroundClass = this.app.environment.isDB
      ? "dbLoginBackground"
      : "bodyBackground";

    this.routeParamsSubscription = this.router.events.subscribe(
      async (event) => {
        if (event instanceof NavigationEnd) {
          if (
            this.backgroundRoutes.some((r) => event.url.includes(r)) ||
            (event.url === "/" && event.urlAfterRedirects === "/login")
          ) {
            this.modalService.dismissAll();
            this.renderer.addClass(this.document.body, backgroundClass);
          } else {
            this.renderer.removeClass(this.document.body, backgroundClass);
          }

          this.app.users.creationOpen = false;
          this.app.profile.viewProfile = false;
          this.app.users.currentUserName = "";
        }
      }
    );

    this.renderer.addClass(this.document.body, backgroundClass);
  }

  ngOnDestroy(): void {
    if (this.routeParamsSubscription) {
      this.routeParamsSubscription.unsubscribe();
    }
  }
}
